var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2998 5.425C8.01574 5.425 6.9748 6.46594 6.9748 7.75V29.45C6.9748 30.7341 8.01574 31.775 9.2998 31.775H27.8998C29.1839 31.775 30.2248 30.7341 30.2248 29.45V18.6C30.2248 18.172 30.5718 17.825 30.9998 17.825C31.4278 17.825 31.7748 18.172 31.7748 18.6V29.45C31.7748 31.5901 30.0399 33.325 27.8998 33.325H9.2998C7.1597 33.325 5.4248 31.5901 5.4248 29.45V7.75C5.4248 5.6099 7.1597 3.875 9.2998 3.875H18.5998C19.0278 3.875 19.3748 4.22198 19.3748 4.65C19.3748 5.07802 19.0278 5.425 18.5998 5.425H9.2998Z",
    fill: "#6C5CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1904 6.38805C26.0063 4.57211 28.9505 4.57211 30.7665 6.38805C32.5824 8.20398 32.5824 11.1482 30.7665 12.9641L19.0756 24.655C18.8385 24.8921 18.5308 25.0459 18.1988 25.0934L13.0841 25.8241C12.0611 25.9702 11.1843 25.0934 11.3304 24.0704L12.0611 18.9557C12.1086 18.6237 12.2624 18.316 12.4995 18.0789L24.1904 6.38805ZM26.9304 14.6082L17.9796 23.559L12.8649 24.2896L13.5955 19.1749L22.5463 10.2241L26.9304 14.6082ZM28.0264 13.5122L29.6704 11.8681C30.8811 10.6575 30.8811 8.69469 29.6704 7.48406C28.4598 6.27344 26.497 6.27344 25.2864 7.48406L23.6423 9.1281L28.0264 13.5122Z",
    fill: "#6C5CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.ee8b4c0268434f8d1e5635213e883945.svg";
export { ForwardRef as ReactComponent };